import NativeSelect from '../../utils/NativeSelect'
import Application from '../../../application'
export default {
    components: {
        NativeSelect
    },
    mounted() {
        this.getAllSchools()
    },
    data: () => ({
        currentStep: 1,
        //Schools
        schoolsHeaders: [
            {
                text: 'Región',
                align: 'left',
                value: 'REGION_NAME'
            },
            {
                text: 'Municipio Escolar',
                align: 'left',
                value: 'MUNICIPALITY'
            },
            {
                text: 'Escuela',
                align: 'left',
                value: 'SCHOOL_NAME'
            },
            {
                text: 'Código de Escuela',
                align: 'left',
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Reporte',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            }
        ],
        searchSchools: '',
        schoolsLoading: true,
        state: {
            isSending: false
        },
        loader: null,
        loadingAction: false,
        enabledEvidence: false,
        schools: [],
        selectedSchool: {},
        //Students
        studentsHeaders: [
            {
                text: 'Grado',
                align: 'left',
                value: 'GRADE'
            },
            {
                text: 'Número de Estudiante',
                align: 'left',
                value: 'STUDENT_ID'
            },
            {
                text: 'Apellidos',
                align: 'left',
                value: 'FULL_LAST_NAME'
            },
            {
                text: 'Nombre',
                align: 'left',
                value: 'FIRST_NAME'
            },
            {
                text: 'Inicial',
                align: 'left',
                value: 'MIDDLE_NAME'
            },
            {
                text: 'Código Transacción',
                align: 'left',
                value: 'TRANSACTION_CODE'
            },
            {
                text: 'Tiene Evidencia',
                align: 'left',
                value: 'HAS_EVIDENCE'
            },
            {
                text: 'Estatus Transacción',
                align: 'left',
                value: 'TRANSACTION_STATUS_DESC'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'STUDENT_ID'
            }
        ],
        searchStudents: '',
        studentsLoading: true,
        students: [],
        selectedStudent: {},
        //Students Transactions
        studentTransactionsDetails: [],
        studentTransactionsHeaders: [
            {
                text: 'Fecha de Transacción',
                align: 'left',
                value: 'TRANSACTION_DATE'
            },
            {
                text: 'Código',
                align: 'left',
                value: 'CODE_DESCRIPTION'
            },
            {
                text: 'Tiene Evidencia',
                align: 'left',
                value: 'HAS_EVIDENCE',
                width: "1%"
            },
            {
                text: 'Evidencias',
                align: 'left',
                value: 'HAS_EVIDENCE',
                width: "100%"
            },
            {
                text: 'Comentario',
                align: 'left',
                value: 'COMMENT',
                width: "100%",
                height: "100%"
            },
            {
                text: 'Estatus de la transacción',
                align: 'left',
                value: 'TRANSACTION_STATUS_ID',
                width: "10%"
            },
            {
                text: 'Guardar',
                align: 'center',
                sortable: false,
                value: 'TRANSACTION_STATUS_ID',
                width: "1%"
            }
        ],
        studentsTransactionsLoading: true,
        TransactionsDetails: []
    }),
    watch: {
        loader() {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        }
    },
    computed: {
        progress() {
            return Math.min(100, this.value.length * 10)
        },
        color() {
            return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
        },
    },
    methods: {
        getAllSchools() {
            var self = this
            self.schoolsLoading = true
            this.$ajax.get("/ENROLLMENT_TRANSACTION/GetAllSchoolsAsync").then(response => {
                self.schools = response.data
                self.schoolsLoading = false
            }).catch(reponse => {
                self.schoolsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReport(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetMonitoriaReport?rp_School=' + props.item.SCHOOL_CODE + '&PreMonitoria=0')
        },
        getStudentsTransactionsBySchoolIdAsync() {
            var self = this
            self.studentsLoading = true
            self.$ajax.get("/ENROLLMENT_TRANSACTION/GetStudentsTransactionsBySchoolIdAsync",
                { SCHOOL_ID_PK: self.selectedSchool.SCHOOL_ID_PK }
            ).then(response => {
                let data = response.data
                // data = data.filter((li, idx, self) => self.map(itm => itm.STUDENT_ID).indexOf(li.STUDENT_ID) === idx) //Remove duplicate Transaction
                data = data.filter((li, idx, self) => self.map(itm => itm.STUDENT_ID))
                self.students = data
                self.studentsLoading = false
            }).catch(reponse => {
                self.studentsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        getStudentsTransactionsDetailsByStudentId() {
            var self = this
            self.studentsTransactionsLoading = true
            //Buscamos la lista de transacciones de un estudiante
            this.$ajax.get("/ENROLLMENT_TRANSACTION/GetStudentsTransactionsDetailsByStudentIdAsync",
                {
                    STUDENT_ID: this.selectedStudent.STUDENT_ID,
                    SCHOOL_CODE: this.selectedStudent.SCHOOL_CODE
                }
            ).then(TransactionsDetails => {
                self.studentTransactionsDetails = TransactionsDetails.data
                //Buscamos la lista de los status
                self.$ajax.get("/ENROLLMENT_TRANSACTION/GetTransactionsStatusListAsync").then(transactionsStatus => {
                    //Buscamos la lista de evidencias
                    for (let i = 0; i < TransactionsDetails.data.length; i++) {
                        self.$ajax.get("/ENROLLMENT_TRANSACTION/GetTransactionsEvidenceListAsync",
                            { ENROLLMENT_TRANSACTION_ID_PK: TransactionsDetails.data[i].ENROLLMENT_TRANSACTION_ID_PK }
                        ).then(transactionsEvidence => {
                            self.setTransactionsEvidences(i, transactionsStatus.data, transactionsEvidence.data, TransactionsDetails.data.length)
                        }).catch(reponse => {
                            self.studentsTransactionsLoading = false
                            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                        })
                    }
                }).catch(reponse => {
                    self.studentsTransactionsLoading = false
                    self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                })
            }).catch(reponse => {
                self.studentsTransactionsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        setTransactionsEvidences(i, transactionsStatus, transactionsEvidence, length) {
            this.studentTransactionsDetails[i].transactionsStatusList = transactionsStatus
            this.studentTransactionsDetails[i].TRANSACTION_DESCRIPTION = this.studentTransactionsDetails[i].EVIDENCES[0].TRANSACTION_DESCRIPTION
            this.studentTransactionsDetails[i].transactionsSelected = []

            //Marcamos la opciones seleccionadas
            this.studentTransactionsDetails[i].EVIDENCES.map(ele => {
                let EVIDENCE_ID_FK = ''
                let valor = transactionsEvidence.some(e => {
                    EVIDENCE_ID_FK = e.EVIDENCE_ID_FK
                    return e.EVIDENCE_ID_FK === ele.EVIDENCE_ID_FK
                });
                ele.Evidence_References = valor ? EVIDENCE_ID_FK : null
            });

            for (var index = 0; index < transactionsEvidence.length; index++) {
                this.studentTransactionsDetails[i].transactionsSelected.push(transactionsEvidence[index].EVIDENCE_ID_FK)
            }
            if (i == length - 1) {
                this.studentsTransactionsLoading = false
            }
        },
        selectSchool(school) {
            this.selectedSchool = school.item
            this.currentStep = 2
            this.getStudentsTransactionsBySchoolIdAsync()
        },
        selectStudent(student) {
            this.selectedStudent = student.item
            this.currentStep = 3
            this.getStudentsTransactionsDetailsByStudentId()
        },
        saveStudentTransaction(studentTransaction, $event) {
            let evidenceReferences = []
            studentTransaction.EVIDENCES.map(e => {
                if (e.Evidence_References !== null)
                    evidenceReferences.push(e.Evidence_References)
            })
            var self = this
            if (!studentTransaction.HAS_EVIDENCE && studentTransaction.TRANSACTION_STATUS_ID_FK == '2') {
                this.$root.$snackbar("La transaccion no se puede cerrar si no tiene evidencia.", { color: 'error' })
            }
            else {
                if (studentTransaction.HAS_EVIDENCE && !evidenceReferences.length) {
                    this.$root.$snackbar("Debe seleccionar al menos 1 evidencia.", { color: 'error' })
                }
                else {
                    var EVIDENCES = []
                    //Cargamos las evidencias
                    for (var i = 0; i < evidenceReferences.length; i++) {
                        EVIDENCES.push({ TRANSACTION_ID_FK: studentTransaction.TRANSACTION_ID_FK, EVIDENCE_ID_FK: evidenceReferences[i] })
                    }
                    //Guardamos la transaccion y las evidencias
                    self.loader = 'loadingAction'
                    self.loading = true
                    self.$ajax.post("/ENROLLMENT_TRANSACTION/SaveStudentTransaction", {
                        STUDENT_ID: studentTransaction.STUDENT_ID,
                        ENROLLMENT_TRANSACTION_ID_FK: studentTransaction.ENROLLMENT_TRANSACTION_ID_PK,
                        HAS_EVIDENCE: studentTransaction.HAS_EVIDENCE,
                        EVIDENCES: EVIDENCES,
                        COMMENT: studentTransaction.COMMENT,
                        TRANSACTION_STATUS_ID_FK: studentTransaction.TRANSACTION_STATUS_ID_FK
                    }).then(response => {
                        self.loading = false
                        this.$root.$snackbar("Los datos fueron guardados correctamente.", { color: 'success' })
                        this.currentStep = 2
                        this.getStudentsTransactionsBySchoolIdAsync()
                    }).catch(response => {
                        self.loading = false
                        this.$root.$snackbar('Ha ocurrido un error mientras se trataba de guardar los datos.', { color: 'error' })
                    })
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/monitoria/transaccion/script.js